import type { FaireProductEntity } from "../../entity_types/product";

export const p_6eh3sbahxq: FaireProductEntity = {
  token: "p_6eh3sbahxq",
  type: "product",
  name: "thanksgiving cotton flour sack tea towel",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/6fb349d206c0a4d64a7d7012589c4bcfb200a21cd0ee4db329004e3f55d4a3b2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/22143701fd325e9882f069e4f3be37cbf8adb8f5c24fb9e2cebc2447fe3c5671.jpeg",
    "https://cdn.faire.com/fastly/4f98e21a3b974f5c70b00de99e94b5a7d1651d223b175a5f836dc81cc0812e42.jpeg",
    "https://cdn.faire.com/fastly/cbb3d7cb41bbf6a74fe84fadb6da0d9c06680e023f3398b52342e0c12c01f094.jpeg",
    "https://cdn.faire.com/fastly/7f995b8589e4125c38a758f4223d6d8e13d1edbd554648b29bb0c85104eabd12.jpeg",
  ],
  priceDollars: 14,
  description:
    'Add a touch of Thanksgiving charm to your kitchen with this 100% cotton tea towel. Cozy autumn illustrations cover the towel making it perfect for washing up, lining a basket, wrapping up treats, or setting out to add seasonal charm to your home.\n\nDetails:\n- 100% cotton flour sack tea towel\n- 19" x 28"\n- Loop for hanging\n- Machine wash and dry\n- Original watercolor artwork by Emily Lex\n',
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-28T05:30:11.399Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
